import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment'
import { Icon } from 'semantic-ui-react'

import { calculateFields } from '../../helpers/training_requirement_helpers';

export default class TrainingRequirementPopup extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      showDateCompletedPicker: false,
      showExpiryDatePicker: false,
      trainingRequirement: {...props.trainingRequirement},
      date_completed_string: '',
      date_completed_moment: '',
      due_date_string: '',
      due_date_moment: '',
      frequency: props.trainingRequirement.frequency
    }

  }

  componentWillReceiveProps(nextProps){
    if(this.props.trainingRequirement !== nextProps.trainingRequirement) return
    const trainingRequirement = {...nextProps.trainingRequirement}
    this.setTrainingRequirement(trainingRequirement)
  }

  setTrainingRequirement = (trainingRequirement) => {
    var { frequency, date_completed, due_date } = trainingRequirement
    var date_completed_string, date_completed_moment, due_date_string, due_date_moment
    if (['X', '', null].includes(date_completed)){
      date_completed_string = ''
      date_completed_moment = ''
    }
    else {
      date_completed_string = moment(date_completed).format("DD-MMM-YYYY")
      date_completed_moment = moment(date_completed).toDate()
    }

    if (!due_date){
      due_date_string = ''
      due_date_moment = ''
    }
    else {
      due_date_string = moment(due_date).format("DD-MMM-YYYY")
      due_date_moment = moment(due_date).toDate()
    }

    this.setState({
      trainingRequirement,
      date_completed_string,
      date_completed_moment,
      due_date_string,
      due_date_moment,
      frequency,
      showDateCompletedPicker: false,
      showDueDatePicker: false
    })
  }

  toggleDateCompletedPicker = (show) => {
    this.setState({showDateCompletedPicker: show})
  }

  toggleDueDatePicker = (show) => {
    this.setState({showDueDatePicker: show})
  }

  onDateSelection = (date, field) => {
    var { trainingRequirement } = this.state
    trainingRequirement[field] = moment(date).local().endOf('day').toDate();
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  onFrequencyChange = (evt) => {
    var { trainingRequirement } = this.state
    trainingRequirement.frequency = evt.target.value==='' ? 0 : parseInt(evt.target.value, 10);
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  onDateChange = (evt) => {
    var name = evt.target.name
    var date = evt.target.value

    if (name==='date_completed'){
      if(date==='') { this.setAsNeeded(); return }
      if(date==='X' || date==='x'){ this.setAsNotNeeded(); return }
    }

    this.toggleInvalidDate(false, name)
    
    if (this.invalidDate(date, name)) return 
    
    var { trainingRequirement } = this.state
    trainingRequirement[name] = moment(date).local().endOf('day').toDate()
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  invalidDate = (date, field) => {
    const months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ]
    var date_split = date.split("-")
    var invalid = (date_split.length !== 3 || parseInt(date_split[0], 10) > 31 || parseInt(date_split[0], 10)  < 1 || 
                  date_split[0].length===0 || !months.includes(date_split[1]) || parseInt(date_split[2], 10) > 3000 || 
                  parseInt(date_split[2], 10) < 2000)

    if (invalid) {
      var {state} = this
      state[field+'_string'] = date
      state[field+'_moment'] = moment()
      if (field==='date_completed') state.invalidDateCompleted = true
      if (field==='due_date') state.invalidDueDate = true
      this.setState(state)
    }
    return invalid
  }

  toggleInvalidDate = (show, field) => {
    var { state } = this
    state.invalidDateCompleted = (field==='date_completed' ? show : false)
    state.invalidDueDate = (field==='due_date' ? show : false)
    this.setState(state)
    return show
  }

  setAsNeeded = () => {
    var { trainingRequirement } = this.state
    trainingRequirement.date_completed = ''
    trainingRequirement.customized_frequency = false
    trainingRequirement.customized_due_date = false
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  setAsNotNeeded = () => {
    var { trainingRequirement } = this.state
    trainingRequirement.date_completed = 'X'
    trainingRequirement.customized_frequency = false
    trainingRequirement.customized_due_date = false
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  updateTrainingDetails = (evt) => {
    if(this.state.invalidDateCompleted || this.state.invalidDueDate) return
    this.props.updateTrainingDetails(this.state.trainingRequirement)
  }

  onRadioChange = (evt) => {
    var { trainingRequirement } = this.state
    if (evt.target.name==='frequency') {
      trainingRequirement.customized_frequency = true
      trainingRequirement.customized_due_date = false
    }
    else if (evt.target.name==='due_date') {
      trainingRequirement.customized_frequency = false
      trainingRequirement.customized_due_date = true
    }
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }
  
  onCustomizedCheckboxChange = (evt) => {
    var { trainingRequirement } = this.state
    const { trainingRequirement: origTrainingRequirement } = this.props;
    if (evt.target.checked) {
      trainingRequirement.customized_frequency = true
      trainingRequirement.customized_due_date = false
    }
    else {
      trainingRequirement.customized_frequency = false
      trainingRequirement.customized_due_date = false
      trainingRequirement.frequency = this.props.defaultFrequency

      if (!origTrainingRequirement.date_completed) trainingRequirement.date_completed = origTrainingRequirement.date_completed;

    }
    calculateFields(trainingRequirement, this.setTrainingRequirement);
  }

  render() {
    const { date_completed_string, due_date_string, frequency, date_completed_moment, due_date_moment, invalidDateCompleted, trainingRequirement, invalidDueDate } = this.state
    return (
      <div className="training-requirement ui tiny modal transition visible active">
        <div className="header">Update Training Record</div>
        <div className="content custom-date-picker-content">
          <form className="ui form">
            <div className="ui message">
              {
                invalidDateCompleted &&
                <div className="error field">
                  ERROR: Please enter a valid date completed. (e.g.{moment(new Date()).format("DD-MMM-YYYY")})
                </div>
              }
              <div className={invalidDateCompleted ? "error field" : "field"} style={{width:'60%'}}>
                <label>Date Completed</label>
                <div className="ui fluid icon input custom-datepicker-input">
                  <input name='date_completed' placeholder={`DD-MMM-YYYY (e.g.${moment(new Date()).format("DD-MMM-YYYY")})`} type="text" value={date_completed_string} onChange={this.onDateChange} onInput={this.onDateChange}/>
                  <Icon name='calendar alternate' onClick={() => this.toggleDateCompletedPicker(true)}/>
                </div>
                {
                  this.state.showDateCompletedPicker &&
                  <div className="react-datepicker-wrapper" onMouseLeave={() => this.toggleDateCompletedPicker(false)}>
                    <DatePicker
                      name='date-completed-picker'
                      selected={date_completed_moment}
                      onChange={ (date) => this.onDateSelection(date, 'date_completed') }
                      inline
                      showYearDropdown
                      showMonthDropdown
                      useShortMonthInDropdown
                      yearDropdownItemNumber={3}
                    />
                  </div>
                }
              </div>
            </div>
            <div className="ui message">
              <div className="field">
                <div className={trainingRequirement.date_completed ? "ui checkbox field" : "ui checkbox field disabled"} >
                  <input type="checkbox" id="customized-checkbox" onChange={this.onCustomizedCheckboxChange} checked={trainingRequirement.customized_frequency || trainingRequirement.customized_due_date}/>
                  <label htmlFor="customized-checkbox">Customized Expiry Date</label>
                </div>
              </div>
              {
                (trainingRequirement.customized_frequency || trainingRequirement.customized_due_date) &&
                <div className="field">
                  <div className="ui radio checkbox" style={{marginRight:'15px', cursor:'pointer'}}>
                    <input type="radio" id="frequency" name="frequency" onChange={this.onRadioChange} checked={trainingRequirement.customized_frequency}/>
                    <label htmlFor="frequency" style={{cursor:'pointer'}}>Customized Refresher Period (years)</label>
                  </div>
                  <div className="ui radio checkbox" style={{marginRight:'15px', cursor:'pointer'}}>
                    <input type="radio" id="due_date" name="due_date" onChange={this.onRadioChange} checked={trainingRequirement.customized_due_date}/>
                    <label htmlFor="due_date" style={{cursor:'pointer'}}>Customized Expiry Date</label>
                  </div>
                  {
                    trainingRequirement.customized_frequency===true &&
                    <div className="ui fluid input" style={{width:'60%'}}>
                      <input placeholder="Years" min="0" type="number" value={frequency} onChange={this.onFrequencyChange}/>
                    </div>
                  }
                  {
                    invalidDueDate &&
                    <div className="error field">
                      ERROR: Please enter a valid due date. (e.g.{moment(new Date()).format("DD-MMM-YYYY")})
                    </div>
                  }
                  {
                    trainingRequirement.customized_due_date===true &&
                    <div className={invalidDueDate ? "error field" : "field"} style={{width:'60%'}}>
                      <div className="ui fluid icon input custom-datepicker-input">
                        <input ref={this.dueDateRef} name='due_date' placeholder={`DD-MMM-YYYY (e.g.${moment(new Date()).format("DD-MMM-YYYY")})`} type="text" value={due_date_string} onChange={this.onDateChange} onInput={this.onDateChange}/>
                        <Icon name='calendar alternate' onClick={() => this.toggleDueDatePicker(true)}/>
                      </div>
                      {
                        this.state.showDueDatePicker &&
                        <div className="react-datepicker-wrapper" onMouseLeave={() => this.toggleDueDatePicker(false)} style={{top: -'310px'}}>
                          <DatePicker
                            name='date-completed-picker'
                            selected={due_date_moment}
                            onChange={ (date) => this.onDateSelection(date, 'due_date') }
                            inline
                            showYearDropdown
                            showMonthDropdown
                            useShortMonthInDropdown
                            yearDropdownItemNumber={3}
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </form>
        </div>
        <div className="actions">
          <button className="ui negative button" onClick={this.props.onClose}>Cancel</button>
          <button className="ui positive button" onClick={this.updateTrainingDetails}>Update</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/components/training_requirement_popup.js